/*!

=========================================================
* Vision UI Free React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-free-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)
* Licensed under MIT (https://github.com/creativetimofficial/vision-ui-free-react/blob/master LICENSE.md)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

export default {
  styleOverrides: {
    root: {
      color: "rgba(80, 100, 140, 0.7)",
      fontSize: "13px",
      lineHeight: "1.4",
      top: "1px",
      userSelect: "none",
      "&.Mui-focused": {
        color: "rgba(60, 90, 160, 0.9)",
      },
      "&.MuiFormLabel-filled, &.MuiInputLabel-shrink": {
        color: "rgba(80, 100, 140, 0.95)",
        fontSize: "11px",
        transform: "translate(12px, -8px) scale(1)",
        backgroundColor: "#ffffff",
        padding: "0 4px",
      },
    },
  },
};

